import { module } from 'angular';
const kayentaStageConfigSection = {
    transclude: {
        sectionHeader: '?sectionHeader',
    },
    bindings: { title: '@' },
    template: `
    <section>
      <ul class="list-inline">
        <li><h5>{{ $ctrl.title }}</h5></li>
        <li><span ng-transclude="sectionHeader"></span></li>
      </ul>
      <div class="horizontal-rule"></div>
      <ng-transclude></ng-transclude>
    </section>
  `,
};
export const KAYENTA_STAGE_CONFIG_SECTION = 'spinnaker.kayenta.stageConfigSection';
module(KAYENTA_STAGE_CONFIG_SECTION, []).component('kayentaStageConfigSection', kayentaStageConfigSection);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2F5ZW50YVN0YWdlQ29uZmlnU2VjdGlvbi5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMva2F5ZW50YS9zdGFnZXMva2F5ZW50YVN0YWdlL2theWVudGFTdGFnZUNvbmZpZ1NlY3Rpb24uY29tcG9uZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxNQUFNLEVBQXFCLE1BQU0sU0FBUyxDQUFDO0FBRXBELE1BQU0seUJBQXlCLEdBQXNCO0lBQ25ELFVBQVUsRUFBRTtRQUNWLGFBQWEsRUFBRSxnQkFBZ0I7S0FDaEM7SUFDRCxRQUFRLEVBQUUsRUFBRSxLQUFLLEVBQUUsR0FBRyxFQUFFO0lBQ3hCLFFBQVEsRUFBRTs7Ozs7Ozs7O0dBU1Q7Q0FDRixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sNEJBQTRCLEdBQUcsc0NBQXNDLENBQUM7QUFDbkYsTUFBTSxDQUFDLDRCQUE0QixFQUFFLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQywyQkFBMkIsRUFBRSx5QkFBeUIsQ0FBQyxDQUFDIn0=